import { render, staticRenderFns } from "./modal-exceed-max-products.vue?vue&type=template&id=940a0626&"
import script from "./modal-exceed-max-products.vue?vue&type=script&lang=js&"
export * from "./modal-exceed-max-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports